import { CustomField } from "./customField";

export class BoolCustomField extends CustomField {
  formatFromRead() {
    this.defaultValue = this.formatSingleValue(this.defaultValue);
    this.customValue = this.formatSingleValue(this.customValue);
  }

  formatSingleValue(value: string | number | boolean | undefined) {
    if (value === "true") return true;
    if (value === "false") return false;
    return value;
  }

  hasValidDefaultInput() {
    const isBooleanType =
      this.defaultValue === "true" ||
      this.defaultValue === "false" ||
      this.defaultValue === 1 ||
      this.defaultValue === 0 ||
      typeof this.defaultValue === "boolean";
    return isBooleanType;
  }

  hasValidCustomInput() {
    const isBooleanType =
      this.customValue === "true" ||
      this.customValue === "false" ||
      this.customValue === 1 ||
      this.customValue === 0 ||
      typeof this.customValue === "boolean";
    return isBooleanType;
  }
}
